module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"reply":"Ответить","open_post":"Перейти","edit":"Редактировать","complain":"Пожаловаться","is_draft":"Черновик","is_draft_moderate":"На модерации","is_draft_rejected":"Снят с публикации","yesterday_at":"Вчера в","today_at":"Сегодня в","at":"в"}}')
  delete Component.options._Ctor
}
